module.exports = __webpack_public_path__ + "img/photo-52.0009eed3.webp";